export type SidebarMode = 'default' | 'visibility';
export const defaultSectionOrder = [
  'customerInfo',
  'knowledge',
  'nativeIntegration',
  'customIntegration',
] as const;

export type SidebarSectionId = (typeof defaultSectionOrder)[number];

export type SidebarCardId =
  | 'contact'
  | 'custom-fields'
  | 'history'
  | 'tracking'
  | 'knowledge-suggestions'
  | 'elevio'
  | (string & {});

export const defaultCustomerInfoOrder: readonly SidebarCardId[] = [
  'contact',
  'custom-fields',
  'history',
  'tracking',
];

export const defaultKnowledgeOrder: readonly SidebarCardId[] = [
  'knowledge-suggestions',
  'elevio',
];
